import { gql } from "@apollo/client";

export const DASHBOARD = gql`
query getDashboard {
  dashboard {
    everHadAppointment
    pets {
      id
      name
      image
      species
      birthdate
      socStatus
      lastAppointmentDate
      isWellnessplan
    }
    appointments {
      id
      active
      start_at
      dateTime
      duration
      status
      description
      appointmentCreateType
      promoCode
      destination_address
      pet {
        id
        name
        image
        speciesName
        species
        breed
        breedName
        birthdate
        gender
      }
      location {
        idLocation
        locationName
        address
        city
        state
        status
        position {
          lat
          lng
        }
        email
        phoneNumber
        timeZone
        background
      }
      reasonsForVisit
      appointmentType
      appointmentTypeId
      allowedToEdit
      feedback {
        questionId
        question
        subText
        answer
      }
      resources {
          id
          name
        }
      underFeedbackDays
    }
      pastAppointments {
      id
      active
      start_at
      dateTime
      duration
      status
      description
      promoCode
      destination_address
      appointmentCreateType
      pet {
        id
        name
        image
        speciesName
        species
        breed
        breedName
        birthdate
        gender
      }
      location {
        idLocation
        locationName
        address
        city
        state
        status
        position {
          lat
          lng
        }
        email
        phoneNumber
        timeZone
        background
      }
      reasonsForVisit
      appointmentType
      appointmentTypeId
      allowedToEdit
      feedback {
        questionId
        question
        subText
        answer
      }
      resources {
          id
          name
        }
      underFeedbackDays
    }
  }
}
`;
